<template>
  <div class="footer">
    <div class="footer-content">
      <!-- 上部 flex：左｜右 -->
      <div class="footer-top-row">
        <div class="footer-left">
          <span class="info">Copyright © 2026 王朋 保留所有权利。</span>
          <!-- 备案上下垂直排列，img官方图标 -->
          <div class="info-group">
            <a class="info" href="https://beian.miit.gov.cn/" target="_blank">
              <img src="@/assets/svg/icp.svg" class="logo">京ICP备2026064090号
            </a>
            <a class="info" href="https://beian.mps.gov.cn" target="_blank">
              <img src="@/assets/beian.png" class="logo">京公网安备11011302008392号
            </a>
          </div>
        </div>
        <div class="footer-right">
          <div class="friend-title">友情链接</div>
          <div class="friend-link-group">
            <a href="/xxx" class="friend-link">期待你的加入</a>
          </div>
        </div>
      </div>

      <p class="footer-dev-text">
        Developed by WangPeng using <a class="footer-dev-link" href="https://cn.vuejs.org">Vue3</a> powered by <a class="footer-dev-link" href="https://www.docker.com">Docker</a>
      </p>

    </div>
  </div>
</template>

<script>
export default {
  name: 'LaputaFooter'
}
</script>

<style scoped>
/* 页脚容器 白色背景，顶部分割线 */
.footer {
  padding: 18px 0;
  display: flex;
  justify-content: center;
  width: 100%;
  background: var(--laputa-body-background-other);
  border-top: 1px solid var(--laputa-footer-separator);
}

.footer-content {
  display: flex;
  flex-direction: column;
  width: 80%;
  box-sizing: border-box;
  position: relative;
}

/* 分割线，版权行和开发声明中间 */
.footer-content::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 56px;
  height: 1px;
  background: var(--laputa-footer-separator);
}

.footer .info {
  font-size: var(--laputa-fontsize-13);
  color: var(--laputa-dark-gray);
  opacity: 0.75;
  margin: 4px 0;
  transition: ease-in-out 0.3s;
  display:block;
  text-decoration: none;
}

.footer a.info:hover {
  opacity: 1;
}

.footer-top-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding-bottom: 24px;
}

.footer-left {
  text-align: left;
}

.info-group {
  margin-top: 8px;
}

/* 右侧友情链接区域 */
.footer-right {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.friend-title {
  font-size:var(--laputa-fontsize-13);
  color:var(--laputa-dark-gray);
  opacity:0.8;
}
.friend-link-group {
  display:flex;
  gap:20px;
}
.friend-link {
  font-size:var(--laputa-fontsize-13);
  color:var(--laputa-dark-gray);
  opacity:0.75;
  text-decoration:none;
  transition:0.3s ease;
}
.friend-link:hover {
  opacity:1;
  color:var(--laputa-primary);
}

/* 底部技术文字 */
.footer-dev-text {
  width: 100%;
  text-align: center;
  font-size: var(--laputa-fontsize-13);
  color: var(--laputa-common-font-color);
  opacity: 0.8;
  margin-top: 8px;
  margin-bottom: 8px;
}

.footer-dev-link {
  color:var(--laputa-primary);
  text-decoration: none;
  font-weight:500;
  transition:0.3s;
}
.footer-dev-link:hover {
  text-decoration: underline;
}
.logo{
  position: relative;
  top: 3px;
  width: 15px;
  height: 15px;
}

/* ========== 手机端适配：仅小屏生效，PC完全不受影响 ========== */
@media (max-width: 768px) {
  .footer {
    padding: 20px 0;
  }
  .footer-content {
    padding: 0 16px;
  }
  .footer-content::after {
    bottom: 48px;
  }

  .footer-top-row {
    flex-direction: column;
    gap: 16px;
    align-items: flex-start;
    padding-bottom: 20px;
  }

  .friend-link-group {
    flex-wrap:wrap;
  }
  .info{
    font-size: var(--laputa-fontsize-13);
  }
  .footer-dev-text {
    font-size: var(--laputa-fontsize-13);
    margin-top: 14px;
  }
  .footer-right{
    display: none;
  }
}
</style>
